import * as React from "react";

import { Trans } from "react-i18next";
import i18next from "i18next";
import i18n from "../../i18n";

import { Callout, Dialog, Tag } from "@blueprintjs/core";

import { TableCustom } from "../Structure/navbar/blueprintTableincludes";
import { mefInterval, mefMontantStr, userColors, userIcons } from "../../utils/mef";
import { TicketManagement } from "../Supervision/UserManagement/TicketManagement";
import { parkLookup } from "../Structure/ParkSelector";
import { deviceLookup } from "../Structure/EquipmentSelector";

export default class IRVEHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fares: undefined,
      creation: false,
      edition: 0,
      price_Kwh: 0,
      price_session: 0,
      price_minutes: 0,
      from: new Date(),
      ticketstatus: "",
    };
  }

  render() {
    return (
      <Callout icon="time" title={<Trans>charging history</Trans>}>
        {/* ticket state on click */}
        <Dialog
          isOpen={this.state.ticketstatus !== ""}
          onClose={() => this.setState({ ticketstatus: "" })}
        >
          <TicketManagement
            isOpen={true}
            server={this.state.ticketserver}
            id={this.state.ticketstatus}
            parkLookup={parkLookup()}
            deviceLookup={deviceLookup()}
            //deviceLookup={props.deviceLookup}
            hideAction={true}
            onClose={() => this.setState({ ticketstatus: "" })}
          />
        </Dialog>
        <TableCustom
          paging={true}
          url={"/irve/sessions"}
          orderBy="date"
          columns={[
            {
              title: "Ticket",
              field: "tokenUid",
              render: (raw) => (
                <Tag
                  onClick={() =>
                    this.setState({
                      ticketstatus:
                        raw.costSettingOverride.accessGroupMemberName,
                      ticketserver: raw.park.server.id,
                    })
                  }
                  style={{ backgroundColor: userColors[0] }}
                  icon={userIcons[0]}
                >
                  {raw.costSettingOverride.accessGroupMemberName}
                </Tag> // todo: add server={event["syncServerId"]}
              ),
            },
            {
              title: <Trans>start date</Trans>,
              field: "startedAt",
              render: (raw) =>
                new Date(raw.startedAt).toLocaleString(i18next.language),
            },
            {
              title: <Trans>end date</Trans>,
              field: "endedAt",
              render: (raw) =>
                raw.endedAt
                  ? new Date(raw.endedAt).toLocaleString(i18next.language)
                  : null,
            },
            /* {
              title: <Trans>location</Trans>,
              field: "location",
              render: (raw) => raw?.location?.name,
            }, */
            {
              title: <Trans>park</Trans>,
              field: "location",
              render: (raw) => raw?.park?.name || raw?.park?.id,
            },
            {
              title: <Trans>EVSE</Trans>,
              field: "evseController",
              render: (raw) => raw?.evseController?.ocppIdentity,
            },
            {
              title: <Trans>consumption</Trans>,
              field: "kwh",
              render: (raw) => raw?.kwh + " Kwh",
            },
            {
              title: <Trans>charging duration</Trans>,
              field: "durationSeconds",
              render: (raw) => {
                if (raw.endedAt)
                  // if finished, take duration from road
                  return mefInterval(raw.durationSeconds);
                else {
                  // else compute interval
                  return mefInterval(
                    (new Date() - new Date(raw.startedAt)) / 1000
                  );
                }
              },
            },
            {
              title: <Trans>price</Trans>,
              field: "price",
              render: (raw) => mefMontantStr(raw.price),
            },
            {
              title: <Trans>charging status</Trans>,
              field: "status",
              render: (raw) => i18n.t("CPSESSIONSTATUS_" + raw.status),
              /* PENDING | STARTING | ERROR | ACTIVE | STOPPING | COMPLETED | CANCELLED */
            },
          ]}
        />
      </Callout>
    );
  }
}
